import React, {useEffect, useState} from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
// import SectionGridAuthorBox from "components/SectionGridAuthorBox/SectionGridAuthorBox";
import SectionSliderStories from "components/SectionSliderStories/SectionSliderStories";
import SectionSliderBanner from "components/SectionSliderBanner/SectionSliderBanner";
import SectionFilter from "components/SectionFilter/SectionFilter";
import SectionEventsShop from "./SectionEventsShop";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import {useGetStoriesQuery} from "store/api/storiesApi";
import {useGetBannersQuery} from "store/api/bannersApi";
import {useGetEventsQuery, useLazyGetEventsQuery} from "store/api";
import {EventType} from "data/types";
import {Loading} from "components/Loading/Loading";

function PageHome() {
  const {data: storiesData, isLoading: isStoriesLoading} = useGetStoriesQuery(
    {}
  );
  const {data: bannersData, isLoading: isBannersLoading} = useGetBannersQuery(
    {}
  );
  const stories = storiesData?.list;
  const banners = bannersData?.list;

  const {data, isLoading} = useGetEventsQuery({});
  const eventsData = data?.eventDB;

  const [filteredEvents, setFilteredEvents] = useState<EventType[]>([]);
  const [getEvents, {data: lazyData, isLoading: isLazyLoading}] =
    useLazyGetEventsQuery();

  const transformEvents = (eventList: any[]): EventType[] =>
    eventList.map((item: any) => ({
      _id: item.event._id,
      nameEvent: item.event.nameEvent,
      date: item.event.date,
      category: item.event.category,
      city: {
        _id: item.event.city._id,
        description: item.event.city.description,
        province: item.event.city.province,
      },
      acronym: item.event.acronym,
      description: item.event.description,
      payments: [],
      sponsors: [],
      existRequirements: item.event.existRequirements,
      requirementsDescription: item.event.requirementsDescription,
      place: item.event.place,
      available: item.event.available,
      publicType: item.event.publicType,
      startTime: item.event.startTime,
      endTime: item.event.endTime,
      isFree: item.event.isFree,
      isDelete: item.event.isDelete,
      img: item.event.img,
      lat: item.event.lat,
      lng: item.event.lng,
      secretLocation: item.event.secretLocation,
      iva: item.event.iva,
      hasCapacity: item.event.hasCapacity,
      maximunTickets: item.event.maximunTickets,
      valueIva: item.event.valueIva,
      imgHeader: item.event.imgHeader,
      haveSubscribers: item.event.haveSubscribers,
      haveDistribution: item.event.haveDistribution,
      type: item.event.type,
      publicationDate: item.event.publicationDate,
      publicationTime: item.event.publicationTime,
      specialDiscounts: item.event.specialDiscounts,
      percentageSpecialDiscounts: item.event.percentageSpecialDiscounts,
      imgDistributionPlace: item.event.imgDistributionPlace,
      localitiesFrom: item.localitiesFrom,
      salesman: item.salesman,
    }));

  useEffect(() => {
    if (eventsData) setFilteredEvents(transformEvents(eventsData));
  }, [eventsData]);

  useEffect(() => {
    if (lazyData?.eventDB) setFilteredEvents(transformEvents(lazyData.eventDB));
  }, [lazyData]);

  // Tema
  useEffect(() => {
    const $body = document.querySelector("body");
    if (!$body) return;
    $body.classList.add("theme-cyan-blueGrey");
    return () => $body.classList.remove("theme-cyan-blueGrey");
  }, []);

  return (
    <div className="nc-PageHome2 relative overflow-hidden">
      <BgGlassmorphism />

      <div className="container relative space-y-12 mb-24 lg:space-y-12 lg:mb-28">
        {!isBannersLoading && banners && (
          <SectionSliderBanner
            banners={banners}
            uniqueClassName="BannersSlider"
          />
        )}

        {!isStoriesLoading && stories?.length > 0 && (
          <SectionSliderStories
            itemPerRow={5}
            uniqueClassName="StoriesSlider"
            stories={stories}
          />
        )}

        {/* SECCIÓN LOGOS SIN TOCAR */}
        {/* <div className="ncSectionLogos grid grid-cols-3 lg:grid-cols-5 gap-5 sm:gap-16">
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo1} alt="logo1" />
            <img className="hidden dark:block" src={logo1Dark} alt="logo1" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo4} alt="logo4" />
            <img className="hidden dark:block" src={logo4Dark} alt="logo4" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo2} alt="logo2" />
            <img className="hidden dark:block" src={logo2Dark} alt="logo2" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo3} alt="logo3" />
            <img className="hidden dark:block" src={logo3Dark} alt="logo3" />
          </div>
          <div className="flex items-end justify-center">
            <img className="block dark:hidden" src={logo5} alt="logo5" />
            <img className="hidden dark:block" src={logo5Dark} alt="logo5" />
          </div>
        </div> */}

        {/* SECTION FILTER + EVENTS */}
        {isLoading || isLazyLoading ? (
          <Loading />
        ) : (
          <div className="relative py-24 space-y-4 mb-8 lg:space-y-4 lg:mb-8">
            <BackgroundSection />
            <SectionFilter
              fetchEvents={getEvents}
              onFilter={(newEvents: EventType[]) =>
                setFilteredEvents(newEvents)
              }
            />
            <SectionEventsShop events={filteredEvents} />
          </div>
        )}

        {/* <div className="relative py-16"> */}
        {/* <BackgroundSection className="bg-neutral-100 dark:bg-black dark:bg-opacity-20" /> */}
        {/* <SectionGridAuthorBox boxCard="box2" /> */}
        {/* </div> */}
      </div>
    </div>
  );
}

export default PageHome;
